var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.803 12.8637C18.0959 13.1566 18.5708 13.1566 18.8637 12.8637C19.1566 12.5708 19.1566 12.0959 18.8637 11.803L17.803 12.8637ZM15.6363 10.697L17.803 12.8637L18.8637 11.803L16.697 9.63634L15.6363 10.697ZM18 6.375C18 3.2684 15.4816 0.75 12.375 0.75V2.25C14.6532 2.25 16.5 4.09683 16.5 6.375H18ZM12.375 0.75C9.2684 0.75 6.75 3.2684 6.75 6.375H8.25C8.25 4.09683 10.0968 2.25 12.375 2.25V0.75ZM6.75 6.375C6.75 9.4816 9.2684 12 12.375 12V10.5C10.0968 10.5 8.25 8.65317 8.25 6.375H6.75ZM12.375 12C15.4816 12 18 9.4816 18 6.375H16.5C16.5 8.65317 14.6532 10.5 12.375 10.5V12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 758",
    d: "M1.66602 4L4.99935 4.00003",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 760",
    d: "M1.66602 9.83337H4.99935",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 759",
    d: "M1.66602 16.5H17.4993",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.17b6dc93f9cc897acd652e16dde6524a.svg";
export { ForwardRef as ReactComponent };